import { useSelector } from "react-redux"
import { productsResource } from "../../helpers/configRoutes/backend_helper"
import {
  UPDATE_PRODUCT,
  RESET_PRODUCT,
  SET_PRODUCTS
} from "./actionTypes"

export const update_product = product => {
  return {
    type: UPDATE_PRODUCT,
    payload: product,
  }
}

export const set_products = products => {
  return {
    type: SET_PRODUCTS,
    payload: products,
  }
}

export const reset_product = () => {
  return {
    type: RESET_PRODUCT,
  }
}

export const get_products = () => {
  return async (dispatch, getState) => {
    const products = getState().product.products

    // Ya tengo datos, no llamo al backend
    if (products && products.length > 0) {
      return products
    }

    // Llamo al backend si no hay datos
    const response = await productsResource('get', {}, false, true)

    dispatch({
      type: SET_PRODUCTS,
      payload: response
    })

    return response
  }
}
